import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "encodableformat"
    }}>{`@encodable/format`}</h1>
    <p><a parentName="p" {...{
        "href": "https://img.shields.io/npm/v/@encodable/format.svg?style=flat"
      }}><img alt="Version" src="https://img.shields.io/npm/v/@encodable/format.svg?style=flat" /></a>{`
`}<a parentName="p" {...{
        "href": "https://david-dm.org/kristw/encodable?path=packages/encodable-format"
      }}><img alt="David (path)" src="https://img.shields.io/david/kristw/encodable.svg?path=packages%2Fencodable-format&style=flat-square" /></a></p>
    <p>{`Utilities for managing time and number formats.
Built on top of D3 formats and support customizing your own formatters.`}</p>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm install @encodable/format global-box
`}</code></pre>
    <h2 {...{
      "id": "example-usage"
    }}>{`Example usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import {
  getTimeFormat,
  formatTime,
  getNumberFormat,
  formatNumber,
  getNumberFormatterRegistry,
} from '@encodable/format';

// Get number format function
const numFormatFn = getNumberFormat('.2f');
// Get time format function
const timeFormatFn = getTimeFormat('%Y-%m-%d');

// or just format directly

formatNumber('.2f', 200); // 200.00
formatTime('%Y-%m-%d', new Date()); // 2020-08-15

// can customize by adding your own formatters
// or override the d3 ones

getNumberFormatterRegistry().registerValue('my-format', (x) => \`haha:\${x}\`);
formatNumber('my-format', 200); // haha:200

`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      